import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { fromStaticDataCountriesActions } from '../../../../static-data/actions';
import * as validate from '../../actions/validate-gov-id-passport.actions';
import * as forgotPasscodeVerify from '../../actions/forgot-passcode-verify.actions';
import * as validateSelector from '../../selectors/validate-gov-id-passport.selectors';
import { fromStaticDataCountrySelector } from '../../../../static-data/selectors';
import * as forgotPasscodeSelector from '../../selectors/forgot-passcode.selectors';
import * as forgotPassocdeVerifySelector from '../../selectors/forgot-passcode-verify.selectors';
import * as logout from '../../actions/logout.actions';
import { IStaticDataCountriesResponse } from '../../../../static-data/models/static-data-countries.model';
import { UntypedFormControl, UntypedFormGroup, FormsModule, Validators } from '@angular/forms';
import { IValidateGovIdPassortRequest, IValidateGovIdPassortResponse } from '../../models/validate-gov-id-passport.model';
import { ErrorResponse, IGenericError } from '../../../../core/models/generic-models';
import { IForgotPasscodeVerifyRequest, IForgotPasscodeVerifyResponse } from '../../models/forgot-passcode-verify.model';
import { ICheckRegisterRequiredRequest } from '../../../../core/models/check-registration.model';
import { APP_CONFIG } from 'src/app/config/app-config.module';
import { AppConfig } from 'src/app/core/config-models/app-config.model';

@Component({
  selector: 'app-identification-check',
  templateUrl: './identification-check.component.html',
  styleUrls: ['./identification-check.component.css']
})
export class IdentificationCheckComponent implements OnInit, OnDestroy {
  staticDataCountries$: Observable<IStaticDataCountriesResponse[]>;
  staticDataCountriesIsLoading$: Observable<boolean>;
  validateResponse$: Observable<IValidateGovIdPassortResponse>;
  forgotPasscodeVerifyIsLoading$: Observable<boolean>;
  forgotPasscodeVerifyResponse$: Observable<IForgotPasscodeVerifyResponse>;
  forgotPasscodeVerifyFailure$: Observable<IGenericError<ErrorResponse>>;
  validateError$: Observable<IGenericError<ErrorResponse>>;
  getUserData$: Observable<ICheckRegisterRequiredRequest>;
  selectedCountry: any;
  countries: IStaticDataCountriesResponse[];
  countryOfIssueId: IStaticDataCountriesResponse;
  userMobileNumber: string;
  subscription: Subscription = new Subscription();
  newCountryNameResults = [];
  countryId: string;

  formSelect = new UntypedFormGroup({
    idPassportInput: new UntypedFormControl('', [Validators.required, Validators.maxLength(15), Validators.minLength(5)])
  });

  constructor(
    private router: Router,
    private store: Store,
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private location: Location
  ) {
    this.store.dispatch(fromStaticDataCountriesActions.loadStaticDataCountries({noLoader: false}));
  }

  ngOnInit(): void {
    this.staticDataCountries$ = this.store.select(fromStaticDataCountrySelector.getStaticDataCountriesResponse);
    this.validateResponse$ = this.store.select(validateSelector.getValidateGovIdPassportResponse);
    this.validateError$ = this.store.select(validateSelector.getValidateGovIdPassportFailure);
    this.forgotPasscodeVerifyResponse$ = this.store.select(forgotPassocdeVerifySelector.getForgotPasscodeVerifyResponse);

    this.subscription.add(
      this.staticDataCountries$.subscribe(countries => {
        this.countries = countries;
      })
    );

    this.getUserData$ = this.store.select(forgotPasscodeSelector.getForgotPasscodeUserNeedsHelpRequest);

    this.subscription.add(
      this.getUserData$.subscribe(userDetails => {
        if (userDetails !== undefined) {
          this.userMobileNumber = userDetails.mobileNumber;
        } else {
          this.store.dispatch(logout.clearStore());
          this.router.navigateByUrl('auth/sign-up');
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  submit() {
    this.countryId =
      this.selectedCountry.countryId === undefined ? this.newCountryNameResults[0].countryId : this.selectedCountry.countryId;

    const req: IForgotPasscodeVerifyRequest = {
      mobileNumber: this.userMobileNumber,
      make: 'web',
      model: 'web',
      totalDiskCapacity: '50',
      uniqueDeviceId: '00000000-0000-0000-0000-000000000000',
      dialingCode: '+27',
      countryId: this.countryId,
      governmentIdNumber: this.formSelect.value.idPassportInput
    };

    this.store.dispatch(forgotPasscodeVerify.loadForgotPasscodeVerify({ request: req }));
  }

  validatePassportId(val) {
    this.store.dispatch(validate.clearValidateGovIdPassportsFailure());
    const req: IValidateGovIdPassortRequest = {
      countryOfIssueId: this.formSelect.value.state,
      identityNumber: this.formSelect.value.idPassportInput
    };

    this.store.dispatch(validate.loadValidateGovIdPassports({ request: req }));
  }

  searchCountryNames(val) {
    this.subscription.add(
      this.store.select(fromStaticDataCountrySelector.getStaticDataCountriesResponse).subscribe(country => {
        this.newCountryNameResults = country.filter(value => value.description.startsWith(val.query.toLowerCase()));
      })
    );
  }

  navBackBtn() {
    this.location.back();
  }
}
